var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nwm-panel"},[_c('b-sidebar',{attrs:{"type":_vm.type,"fullheight":_vm.fullheight,"fullwidth":_vm.fullwidth,"overlay":_vm.overlay,"right":_vm.right,"can-cancel":false},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("content"),_vm._t("bottom")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }